import React__default, { useContext } from 'react';
import cn from 'classnames';
import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import styles from 'ui-components/RadioGroup.scss';

var _excluded = ["children", "id"];
var RadioGroupContext = /*#__PURE__*/React__default.createContext({
  name: null,
  onChange: function onChange() {
    return undefined;
  },
  value: null
});
var RadioGroup = function RadioGroup(_ref) {
  var className = _ref.className,
    onChange = _ref.onChange,
    name = _ref.name,
    children = _ref.children,
    value = _ref.value;
  return /*#__PURE__*/React__default.createElement(RadioGroupContext.Provider, {
    value: {
      onChange: onChange,
      value: value,
      name: name,
      styles: styles
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    role: "radiogroup",
    className: className
  }, children));
};
var Radio = function Radio(_ref2) {
  var _cn;
  var children = _ref2.children,
    id = _ref2.id,
    props = _objectWithoutPropertiesLoose(_ref2, _excluded);
  var _useContext = useContext(RadioGroupContext),
    onChange = _useContext.onChange,
    name = _useContext.name,
    checkedItem = _useContext.value;
  var val = props.name !== "null" ? props.value : "";
  var active = checkedItem === val;
  return /*#__PURE__*/React__default.createElement("label", _extends({}, props, {
    className: cn(styles.radio, props.className, (_cn = {}, _cn[styles.radioChecked] = active, _cn))
  }), /*#__PURE__*/React__default.createElement("input", _extends({}, props, {
    id: id,
    className: styles.input,
    name: props.name !== "null" ? props.name : name,
    value: val,
    checked: active,
    type: "radio",
    onChange: onChange
  })), /*#__PURE__*/React__default.createElement("div", {
    className: styles.button
  }), children);
};

export { Radio, RadioGroup, RadioGroupContext };
//# sourceMappingURL=index.js.map
